import React from 'react';

import "./Terms.scss";

import { Article } from "../../../elements/Article/Article";

export const Terms = (props)=>{
    const {} = props;
    
    return (
        <Article className="Terms wall block" src="/langs/docs/terms.md" local/>
    )
}